import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
//EBX638: Fetch active trials
export const fetchActiveTrials = () => {
  return http.get(`${getFullUrl('app-api')}/trials/v1/hub-trials/?active=true&portalId=${PortalIdParser.get()}`).catch(error => {
    Raven.captureException(new Error('Failed to fetch active trials - EBX638'), {
      extra: {
        error
      }
    });
    throw error;
  });
};